import { paths, SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY } from 'config'
import { tryStorageAccess } from './tryStorageAccess'

// Saved for this tab, as other tabs may extend the session at the same time,
// and shared, as the sign-in link may be opened in another tab
export const saveSessionExtensionReturnPath = (path: string) => {
  tryStorageAccess(() =>
    window.sessionStorage.setItem(
      SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY,
      path
    )
  )
  tryStorageAccess(() =>
    window.localStorage.setItem(SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY, path)
  )
}

// Removed on read, so a later reauthentication can't go back to a stale page
export const takeSessionExtensionReturnPath = () => {
  const path = tryStorageAccess(
    () =>
      window.sessionStorage.getItem(
        SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY
      ) ??
      window.localStorage.getItem(SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY)
  )

  tryStorageAccess(() =>
    window.sessionStorage.removeItem(SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY)
  )
  tryStorageAccess(() => {
    // Kept if another tab has saved its own path since
    if (
      window.localStorage.getItem(SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY) ===
      path
    )
      window.localStorage.removeItem(SESSION_EXTENSION_RETURN_PATH_STORAGE_KEY)
  })

  // Only paths within the app are followed
  return path?.startsWith('/') && !path.startsWith('//') ? path : paths.home
}
